// extracted by mini-css-extract-plugin
export var emptyState = "_60-d";
export var statCard = "_60-c";
export var table = "_60-0";
export var tableCell = "_60-4";
export var tableCellClickable = "_60-5 _60-4";
export var tableCellDefault = "_60-6 _60-4";
export var tableCellEmpty = "_60-8";
export var tableCellWithValue = "_60-7";
export var tableContainer = "_60-e";
export var tableHeaderWeight = "_60-1";
export var tableHeaderZone = "_60-2";
export var tableRowHeader = "_60-3";
export var viewModeButton = "_60-9";
export var viewModeButtonActive = "_60-a _60-9";
export var viewModeButtonInactive = "_60-b _60-9";